import * as React from 'react';

import {
  ListItemButton,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import _startCase from 'lodash/startCase';

import FormAvatar from './FormAvatar';

interface FormDrawerListItemProps {
  color: string | null | undefined;
  title: string | undefined;
  isExternal?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
}

function FormDrawerListItem({ color, title, isExternal, onClick }: FormDrawerListItemProps) {
  return (
    <ListItemButton onClick={onClick}>
      {!isExternal && (
        <ListItemAvatar>
          <FormAvatar color={color} title={title} />
        </ListItemAvatar>
      )}
      {isExternal && (
        <ListItemIcon>
          <OpenInNewIcon />
        </ListItemIcon>
      )}
      <ListItemText primary={_startCase(title)} />
    </ListItemButton>
  );
}

export default FormDrawerListItem;
